import { createContext, useContext } from 'react';
import { createPortal as createReactPortal } from 'react-dom';

/**
 * Get the root element for portals, creating it if it doesn't exist.
 */
export function getDefaultPortalContainer() {
    let element = document.getElementById('portals-root');
    if (element) {
        return element;
    }

    element = document.createElement('div');
    element.setAttribute('id', 'portals-root');
    document.body.appendChild(element);
    return element;
}

export const PortalContext = createContext<() => HTMLElement>(getDefaultPortalContainer);

/**
 * Create a portal to render children in a different part of the DOM.
 * By default, the portal is rendered in a portal root element appended to the body.
 */
export function Portal(props: { children: React.ReactNode; container?: HTMLElement }) {
    const getPortalContainer = useContext(PortalContext);
    return createReactPortal(props.children, props.container ?? getPortalContainer());
}
